window.$ = window.jQuery = require('jquery');
import * as Popper from "@popperjs/core"
import * as bootstrap from 'bootstrap';
import AirDatepicker from 'air-datepicker';
import localeZh from 'air-datepicker/locale/zh';
import 'air-datepicker/air-datepicker.css';

window.Swal = require('sweetalert2');
(function($) {
    new AirDatepicker('.dp', {
        locale: localeZh,
        dateFormat: 'yyyy-MM-dd',
    })
    // IE關閉smooth scroll
    if(navigator.userAgent.match(/Trident\/7\./)) {
        document.body.addEventListener("mousewheel", function() {
            event.preventDefault();
            let wd = event.wheelDelta;
            let csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }
    $('.main').css('min-height', $(window).height() - $('.footer').outerHeight())
})($);
